import { render, staticRenderFns } from "./QFormNewAgent.vue?vue&type=template&id=830b0626&"
import script from "./QFormNewAgent.vue?vue&type=script&lang=js&"
export * from "./QFormNewAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports